import { MonochromeMark } from "@sylviq/ui-react-web/components/ui/MonochromeMark";
import { ProductLockup } from "@sylviq/ui-react-web/components/shell/ProductLockup";

/** Square SYLVIQ wordmark. The file is a black path, so this paints it with
 * the current text color and stays visible on the dark site. */
export function BrandLockup({
  className = "h-12 w-12",
  label = "SYLVIQ",
}: {
  className?: string;
  /** Set to null when a parent link already names the brand. */
  label?: string | null;
}) {
  return (
    <ProductLockup mark={<MonochromeMark src="/brand/sylviq-mark-3.svg" className={className} label={null} />} wordmark="SYLVIQ" aria-label={label ?? undefined} />
  );
}
